import { standardStrategy, getDefaultLoader, LoadPiletsOptions, PiletLoadingStrategy, PiletsLoaded, PiletRequester, PiletEntries } from 'piral-base';

const priorityLoadingStrategy: PiletLoadingStrategy = (options: LoadPiletsOptions, cb: PiletsLoaded): Promise<void> => {
    let loader = options.fetchPilets;
    let newLoader: PiletRequester = (): Promise<PiletEntries> => {
        return new Promise((resolve, reject) => {
            loader().then(e => {
                // Order by priority
                let sorted = e.sort((a: any, b: any) => {
                    if (a.priority !== undefined && b.priority !== undefined) {
                        return b.priority - a.priority; // Higher priority first
                    } else if (a.priority !== undefined) {
                        return -1; // a comes first
                    } else if (b.priority !== undefined) {
                        return 1; // b comes first
                    }
                    return 0; // Maintain original order if no priority
                });
                resolve(sorted);
            });
        });
    }
    return new Promise((resolve, reject) => {
        standardStrategy({ ...options, fetchPilets: newLoader }, cb).then(_ => {
            resolve();
        })
    });
}

export default priorityLoadingStrategy;